import type { ApiRestaurants } from '@bonboca/shared-schemas';

/**
 * Centralised React Query key factory.
 * All keys are arrays so invalidation by prefix works correctly.
 */
export const queryKeys = {
  // Customer — restaurants
  publicRestaurants: (query: Omit<ApiRestaurants.PublicRestaurantsClientQuery, 'cursor'>) =>
    ['public', 'restaurants', query] as const,
  publicRestaurant: (slug: string) => ['public', 'restaurant', slug] as const,
  publicMenu: (slug: string) => ['public', 'menu', slug] as const,
  publicRestaurantDeliveryPricing: (slug: string) =>
    ['public', 'restaurant', slug, 'delivery-pricing'] as const,
  publicRestaurantReviews: (slug: string) => ['public', 'restaurant', slug, 'reviews'] as const,

  // Customer — payment providers
  paymentProviders: () => ['payment-providers'] as const,

  // Customer — geocoding
  reverseGeocode: (lat: string, lng: string) => ['geocode', 'reverse', lat, lng] as const,
  forwardGeocode: (q: string) => ['geocode', 'forward', q] as const,
  suggestGeocode: (q: string) => ['geocode', 'suggest', q] as const,

  // Customer — orders
  order: (orderId: string) => ['order', orderId] as const,
  orderReview: (orderId: string) => ['order', orderId, 'review'] as const,
  orderPricingPreview: (key: string) => ['order', 'pricing-preview', key] as const,
  customerOrders: () => ['customer', 'orders'] as const,

  // Me
  meRestaurants: () => ['me', 'restaurants'] as const,
  meStats: () => ['me', 'stats'] as const,
  meAddresses: () => ['me', 'addresses'] as const,

  // Manage — restaurant
  restaurantOwnerDetail: (restaurantId: string) => ['manage', restaurantId, 'detail'] as const,
  restaurantOrders: (restaurantId: string) => ['manage', restaurantId, 'orders'] as const,
  restaurantDisputes: (restaurantId: string) => ['manage', restaurantId, 'disputes'] as const,
  restaurantMembers: (restaurantId: string) => ['manage', restaurantId, 'members'] as const,
  restaurantPayouts: (restaurantId: string) => ['manage', restaurantId, 'payouts'] as const,
  restaurantVouchers: (restaurantId: string) => ['manage', restaurantId, 'vouchers'] as const,
  restaurantReviews: (restaurantId: string) => ['manage', restaurantId, 'reviews'] as const,
} as const;
